module.exports = __webpack_public_path__ + "static/media/presentation.7a442a71.svg";